export default "__VITE_ASSET__CHBMZdcL__"